import { useContext, useState } from 'react';
import Button from '../../ui/Button';
import Heading from '../../ui/Heading';
import Tag from '../../ui/Tag';
import TextWithTooltip from '../../ui/TextWithTooltip';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import { toast } from 'sonner';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import yellowMetaIcon from '../../assets/greenpill/yellowMetaIcon.png';
import ChangeWalletWhite from '../greenpill/ChangeWalletWhite';
import ChangeWalletModal from '../greenpill/ChangeWalletModal';
import GradientBorder from '../../ui/GradientBorder';
import { useWallet } from '@solana/wallet-adapter-react';

function ProfileBio() {
    const { userProfile, yourImpacts } = useOutletContext();
    const { dispatch } = useContext(AuthContext);
    const wallet = useWallet();
    const navigate = useNavigate();
    const impactDetails = yourImpacts[0];
    const [linkingWalletModal, setLinkingWalletModal] = useState({
        from: '',
        type: '',
    });
    const { selectedPowers } = useOutletContext();
    const handleChangeWalletAddress = async (from, type) => {
        setLinkingWalletModal({
            from,
            type,
        });
    };

    const linkHandler = async (type) => {
        if (type === 'metamask') {
            const metaMaskProvider = getMetaMaskProvider();
            if (!metaMaskProvider) {
                const installUrl = 'https://metamask.io/download.html';
                toast.info('Opening MetaMask installation page in a new tab...');
                window.open(installUrl, '_blank'); // Open the URL in a new tab
                // toast.error('MetaMask is not installed or unavailable');
                return;
            }
            const accounts = await metaMaskProvider.request({
                method: 'eth_requestAccounts',
            });

            if (!accounts || accounts.length === 0) {
                toast.error('Failed to connect wallet');
                return;
            }

            const newWallet = accounts[0]?.toLowerCase();

            const response = await updateWallet(newWallet, undefined);
            if (response?.response?.data?.code === 400) {
                toast?.error(response?.response?.data?.message);
            }

            if (response?.evmAddress) {
                // toast?.success('Wallet changed successfully');
                dispatch({ type: 'changeWalletEVM', payload: newWallet });
                // or 'phantom' depending on type
            }
        }

        if (type === 'phantom') {
            try {
                const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
                if (!phantom || !phantom.adapter) {
                    toast.error('Phantom wallet not found');
                    return;
                }

                if (phantom.adapter?.name !== 'Phantom') {
                    await wallet.select(phantom.adapter.name);
                }

                if (!phantom.adapter.connected) {
                    await phantom.adapter.connect();
                }

                const publicKey = phantom.adapter.publicKey;
                if (!publicKey) {
                    toast.error('Failed to get Phantom wallet address');
                    return;
                }

                const newWallet = publicKey.toBase58();
                console.log(newWallet, 'working on phantom');

                const response = await updateWallet(undefined, newWallet);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                    return;
                }

                console.log(response, 'working on phantom');

                if (response?.walletAddress) {
                    dispatch({ type: 'changeWalletSolana', payload: response?.walletAddress });
                }
            } catch (error) {
                console.error('Phantom Wallet Error:', error);
                toast.error('Error connecting to Phantom wallet');
            }
        }
    };
    return (
        <>
            <div className="w-full mb-4">
                <Heading className={'text-secondaryText'} type={'medium'}>
                    {userProfile?.evmAddress || userProfile?.walletAddress
                        ? 'Linked Wallets'
                        : 'No Wallet linked to Profile'}
                </Heading>

                <div className={`flex flex-col gap-3`}>
                    {userProfile?.evmAddress ? (
                        <div className="flex gap-2   ">
                            <img className="w-7 h-7 object-cover rounded-full" src={greenpillmetamask} alt="" />
                            <div>
                                <p className={`    `}>
                                    <span className=" font-semibold">Linked Wallet:</span>
                                    <span>
                                        {userProfile?.evmAddress.slice(0, 4)}...
                                        {userProfile?.evmAddress.slice(-4)}
                                    </span>
                                    <span
                                        onClick={() => handleChangeWalletAddress('change', 'metamask')}
                                        className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                    >
                                        change
                                    </span>{' '}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <button
                            onClick={() => linkHandler('metamask')}
                            type="button"
                            className={` px-4 py-2 flex items-center gap-2 w-[12.5rem] rounded-md text-white  bg-metamask-gradient `}
                        >
                            <img className="w-7 h-7 object-cover rounded-full" src={yellowMetaIcon} alt="metamask" />
                            <span>
                                Link <span className="font-semibold">Metamask</span>{' '}
                            </span>
                        </button>
                    )}
                    {userProfile?.walletAddress ? (
                        <div className="flex gap-2 w-full mt-2  ">
                            <img className="w-7 h-7 object-cover rounded-full" src={greenpillphantom} alt="" />
                            <div>
                                <p className={`    `}>
                                    <span className=" font-semibold">Linked Wallet:</span>
                                    <span>
                                        {userProfile?.walletAddress.slice(0, 4)}...
                                        {userProfile?.walletAddress.slice(-4)}
                                    </span>
                                    <span
                                        onClick={() => handleChangeWalletAddress('change', 'phantom')}
                                        className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                    >
                                        change
                                    </span>{' '}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <button
                            onClick={() => linkHandler('phantom')}
                            type="button"
                            className={` px-4 py-2 flex items-center gap-2 rounded-md  w-[12.5rem] text-white bg-phantom-gradient  `}
                        >
                            <img className="w-7 h-7 object-cover rounded-full" src={greenpillphantom} alt="metamask" />
                            <span>
                                Link <span className="font-semibold">Phantom</span>{' '}
                            </span>
                        </button>
                    )}
                </div>
            </div>

            {linkingWalletModal?.type === 'metamask' && (
                <div>
                    <ChangeWalletModal
                        close={() => handleChangeWalletAddress('', '')}
                        handleChangeWalletAddress={handleChangeWalletAddress}
                        type={linkingWalletModal?.type}
                        linkedWallet={userProfile?.evmAddress}
                        from={linkingWalletModal?.from}
                    />
                </div>
            )}

            {linkingWalletModal?.type === 'phantom' && (
                <div>
                    <ChangeWalletModal
                        close={() => handleChangeWalletAddress('', '')}
                        handleChangeWalletAddress={handleChangeWalletAddress}
                        type={linkingWalletModal?.type}
                        linkedWallet={userProfile?.walletAddress}
                        from={linkingWalletModal?.from}
                    />
                </div>
            )}
            <div className="mb-4">
                <Heading className={'text-secondaryText'} type={'medium'}>
                    Bio
                </Heading>
                <p className="text-textPrimary">{userProfile?.bio || ''}</p>
            </div>
            <div className="mb-6">
                <TextWithTooltip hoverOverText="Superpowers" expandedTextWidth="w-[332px]">
                    <p className="text-textSecondary">
                        Superpowers are the skills you are good at. Setup your superpowers accurately to get improved
                        matching with earning opportunities.
                    </p>
                </TextWithTooltip>
                <div className="flex items-center flex-wrap mt-2 gap-2">
                    {selectedPowers.length > 0 ? (
                        selectedPowers.map((impact) => (
                            <Tag
                                key={impact}
                                bg={"bg-tagSuperPowerBg"}
                                textColor={"text-tagSuperPowerText"}
                                className="font-semibold border  px-4 py-1  border-tagColor"
                                text={impact}
                            />
                        ))
                    ) : (
                        <p className="text-textPrimary">
                            Set up your Superpowers!{' '}
                            <span onClick={() => navigate('editprofile')} className="text-textBrandBlue cursor-pointer">
                                Add Superpowers{'->'}
                            </span>
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}

export default ProfileBio;
